import { render, staticRenderFns } from "./Garbage.vue?vue&type=template&id=0420dc3b&lang=pug&"
import script from "./Garbage.vue?vue&type=script&lang=js&"
export * from "./Garbage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports